import { ContactType } from "types/enum";
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getCustomerPhoneListApi = (async (CustomerPositionId ,Current,type=1) => await http({
    url: Current  ? 
    type===ContactType.Phone?
    ENDPOINTS.BaseInformation.CurrentPersonContact.phoneDictionary
    :ENDPOINTS.BaseInformation.CurrentPersonContact.mobileDictionary
    
    :  type===ContactType.Phone?
    ENDPOINTS.BaseInformation.CustomerPosition.phoneDictionary
    :ENDPOINTS.BaseInformation.CustomerPosition.mobileDictionary,
    method: 'get',
    params: {
        CustomerPositionId,
    }
}).then((res) => {

    return res.data.Data
}).catch((err) => {

    return Promise.reject( err);
})
)

export const postCustomerPhoneListApi = (data  ,Current) => http({
    url: Current  ? ENDPOINTS.BaseInformation.CurrentPersonContact.Load  :  ENDPOINTS.BaseInformation.CustomerPosition.brows,
    method: 'post',
    data:data
    
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});